import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import type { UnderlyingResultTableProps } from '../Common';
import { getTableLength } from '../Common';

export const EquityUnderlyingResultTable: FC<UnderlyingResultTableProps> = ({ options, children }) => {
  const displayedResultsCount = getTableLength(options);
  return (
    <table className="table table-sm table-hover border-top" data-e2e="underlying-result-panel">
      <thead>
        <tr>
          <FormattedMessage id="name" tagName="th" />
          <FormattedMessage id="underlying.CCY" tagName="th" />
          <FormattedMessage id="underlying.BBG" tagName="th" />
          <FormattedMessage id="underlying.RIC" tagName="th" />
          <th />
        </tr>
      </thead>
      <tbody>{children}</tbody>
      {displayedResultsCount < options.length && (
        <tfoot>
          <tr>
            <td colSpan={3}>{`+ ${options.length - displayedResultsCount}...`}</td>
          </tr>
        </tfoot>
      )}
    </table>
  );
};
